import { render, staticRenderFns } from "./landPageUser.vue?vue&type=template&id=c9ed6ba6"
import script from "./landPageUser.vue?vue&type=script&lang=js"
export * from "./landPageUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports